import { MenuItem, Text } from "@chakra-ui/react"
import PropTypes from "prop-types"
import { useEffect } from "react"
import { useBrandedTranslation } from "../../../../../../common/hooks/useBrandedTranslation"
import useModal from "../../../../../../common/hooks/useModal"
import LoadingIcon from "../../../../../shared/DownloadButton/LoadingIcon"
import { C3dViewer } from "../../../../../shared/Icons"
import { useModelViewer3dData } from "../../../context/ModelViewer3dContext"
import { getModelViewer3dString } from "../../../helpers/get-model-viewer-3d-string"
import ModelViewer3dModal from "../../ModelViewer3dModal"

const ModelViewer3dMenuItem = ({ articleCode, setIsModalOpenFromMenu }) => {
  const { t } = useBrandedTranslation()
  const { isLoading, error, data } = useModelViewer3dData()
  const modelUrlsString = getModelViewer3dString(articleCode, data)

  const { Modal, onOpen, onClose, isOpen } = useModal()

  useEffect(() => {
    /* Made a custom change in the o3dv.min.js file so that it listens for postMessage events with event.data === "modelViewer"
    Init the event each time the component is re-rendered and the modal is open, this handles re-render of the ArticleTableContainer on resize of window
    Wait for the animation to finish so it doesn't stutter */
    if (isOpen) setTimeout(() => window.postMessage("modelViewer"), 300)
  })

  const handleOpen = () => {
    if (setIsModalOpenFromMenu) setIsModalOpenFromMenu(true)
    onOpen()
  }

  const handleClose = () => {
    if (setIsModalOpenFromMenu) setIsModalOpenFromMenu(false)
    onClose()
  }

  // If there is an error in the API call or no 3D data is present for this article, don't show the menu item
  if (error || !modelUrlsString) return null

  return (
    <>
      <MenuItem
        icon={isLoading ? <LoadingIcon /> : <C3dViewer />}
        isDisabled={isLoading}
        onClick={handleOpen}
        aria-label="Open 3D viewer"
      >
        <Text fontWeight="medium">{t("pdp-article-more-model-viewer")}</Text>
      </MenuItem>

      <ModelViewer3dModal Modal={Modal} modelUrlsString={modelUrlsString} handleClose={handleClose} />
    </>
  )
}

export default ModelViewer3dMenuItem

ModelViewer3dMenuItem.propTypes = {
  articleCode: PropTypes.string.isRequired,
  setIsModalOpenFromMenu: PropTypes.func,
}
